import { render, staticRenderFns } from "./AtividadeModal.vue?vue&type=template&id=8f2cafb4&scoped=true"
import script from "./AtividadeModal.vue?vue&type=script&lang=js"
export * from "./AtividadeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2cafb4",
  null
  
)

export default component.exports